"use client";

import Link from "next/link";

import { cn } from "@perceptron/utils/cn";

import { Button } from "./button";
import { Icon } from "./icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

const DEFAULT_SUPPORT_EMAIL = "support@perceptron.inc";

export type SupportButtonProps = {
  ariaLabel: string;
  tooltip: string;
  href?: string;
  className?: string;
  iconClassName?: string;
};

export const SupportButton = ({
  ariaLabel,
  tooltip,
  href = `mailto:${DEFAULT_SUPPORT_EMAIL}`,
  className,
  iconClassName,
}: SupportButtonProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button asChild className={cn("group/support px-2", className)} size="sm" variant="link">
          <Link aria-label={ariaLabel} className="flex items-center justify-center" href={href}>
            <Icon className={cn("size-5", iconClassName)} name="help-circle" />
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent theme="dark">
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
};
